import { useContext, useState } from "react";
import { useAsyncEffect } from "../../../hooks/UseAsyncEffect"
import { toCurrency, toFormattedDate, toPercentage } from "../../../utilities/FormatHelpers";
import { AccountContext } from "../AccountContext";


export function RegularPaymentHistory(props: {lastUpdatedDate}) {
  const { accountId, regularPaymentService, setError } = useContext(AccountContext);
  const [loading, setLoading] = useState(true as boolean);
  const [history, setHistory] = useState<[]>();

  useAsyncEffect(async () => {
    try {
      setLoading(true);
      var history = await regularPaymentService.getHistory(accountId);
      setHistory(history?.history);
    }
    catch (error) {
      setError(error);
    }
    finally {
      setLoading(false);
    }
  }, [accountId, props.lastUpdatedDate]);

  return (
    <>
      <h2>History</h2>
      {loading && <div className="ui active centered inline loader" />}
      
      {!loading && (!history || history.length == 0) && <div>No history found</div>}

      {!loading && history && history.length > 0 &&
        <table className="ui compact table" style={{ marginBottom: "20px" }}>
          <thead>
            <tr>
              <th>Sort Code</th>
              <th>Account Number</th>
              <th>Payment Type </th>
              <th>Fixed Amount</th>
              <th>Percentage Amount</th>
              <th>Collection Date Days Adjustment</th>
              <th>Reference</th>
              <th>Status</th>
              <th>Change Date</th>
              <th>Cancellation Reason</th>
              <th>Bacs Reason Code</th>
              <th>Collection Suspended</th>
            </tr>
          </thead>
          <tbody>
            {history.map((h: any) => (
              <tr key={`${h.changeDate}${h.status}`}>
                <td>{h.sortCode}</td>
                <td>{h.bankAccountNumber}</td>
                <td>{h.paymentType}</td>
                <td>{toCurrency(h?.fixedAmount?.value)}</td>
                <td>{toPercentage(h?.percentageAmount)}</td>
                <td>{h?.collectionDateAdjustmentDays}</td>
                <td>{h.reference}</td>
                <td>{h.status}</td>
                <td>{toFormattedDate(h.changeDate)}</td>
                <td>{h.cancellationReason}</td>
                <td>{h.bacsReasonCode}</td>
                <td>{h.collectionSuspended ? "Yes" : "No"}</td>
              </tr>
            ))}
          </tbody>
        </table>}
    </>)
}